module.exports = __webpack_public_path__ + "images/7ef5a8bcf55daeebf410bf7f5a5b34a6.svg";